module.exports = __webpack_public_path__ + "img/shsb.f24be616.png";